import ExamBanner from './ExamBanner'
export default ExamBanner
